import { render, staticRenderFns } from "./jobInfo.vue?vue&type=template&id=510ed95c&scoped=true"
import script from "./jobInfo.vue?vue&type=script&lang=js"
export * from "./jobInfo.vue?vue&type=script&lang=js"
import style0 from "./jobInfo.vue?vue&type=style&index=0&id=510ed95c&prod&lang=scss&scoped=true"
import style1 from "./jobInfo.vue?vue&type=style&index=1&id=510ed95c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ed95c",
  null
  
)

export default component.exports